@if (!screen.showBottomNav()) {
<ion-menu contentId="main-content" type="overlay">
  <ion-content>
    <ion-list lines="none">
      @for (item of navItems; track item.path) {
      <ion-menu-toggle auto-hide="false">
        <ion-item [routerLink]="item.path" routerLinkActive="active-link">
          <ion-icon slot="start" [name]="item.icon"></ion-icon>
          <ion-label>{{ item.label }}</ion-label>
        </ion-item>
      </ion-menu-toggle>
      }
    </ion-list>
  </ion-content>
</ion-menu>
}

<ion-router-outlet id="main-content" [animated]="false"></ion-router-outlet>

@if (screen.showBottomNav()) {
<x-bottom-nav [items]="navItems" />
}

<!-- Renders nothing unless a demo session is running. -->
<app-demo-badge />
